import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import CombinedTodo from "./CombinedTodo";

export default function TodoList({ completed }) {
  const todos = useSelector((state) => state.todos);
  const filters = useSelector((state) => state.filters);
  const dispatch = useDispatch();
  const [editTitle, setEditTitle] = useState({
    showInput: false,
    editId: "",
  });

  useEffect(() => {
    dispatch(fetchTodos);
  }, [dispatch]);

  // const filterByStatus = (todo) => {
  //   const { status } = filters;
  //   switch (status) {
  //     case "Complete":
  //       return todo.completed;

  //     case "Incomplete":
  //       return !todo.completed;

  //     default:
  //       return true;
  //   }
  // };

  const filterByColors = (todo) => {
    const { colors } = filters;
    if (colors.length > 0) {
      return colors.includes(todo?.color);
    }
    return true;
  };

  return (
    <div className='mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto'>
      {todos
        .filter(filterByColors)
        .filter((todo) => todo.completed === completed)
        .map((todo) => (
          <CombinedTodo editTitle={editTitle} setEditTitle={setEditTitle} todo={todo} key={todo.id} />
        ))}
    </div>
  );
}
